function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h12v12H0z"
}), React.createElement("g", {
  fill: "#595959"
}, React.createElement("path", {
  d: "M11.134 4.443c-.294.624-.978 1.598-1.548 2.336a5.119 5.119 0 0 1-.026.033l.083.066c.57.446 1.181.87 1.836 1.27l-.461.844c-.634-.306-1.33-.78-2.092-1.423a11.03 11.03 0 0 1-.034-.028C8.427 7.99 7.835 8.476 7.115 9l-.579-.882a10.247 10.247 0 0 0 1.585-1.304 7.85 7.85 0 0 1-1.007-1.3l.865-.501c.269.397.542.75.818 1.06l.006-.007c.507-.607.9-1.149 1.179-1.623H6v-.94h2.483V2H9.49v1.503H12v.94h-.866zM2.412 3h1.176L6 9H4.895l-.574-1.504H1.68L1.105 9H0l2.412-6zm-.424 3.69h2.024l-.99-2.631h-.035l-.999 2.63z"
})));

var SvgIcLang = function SvgIcLang(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcLang, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-lang.7840676b.svg";
export { ForwardRef as ReactComponent };